import { NgModule, APP_INITIALIZER } from '@angular/core';
import { RouterModule, Routes }  from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import {ImageCropperComponent, CropperSettings} from 'ng2-img-cropper';
//import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { ControlMessagesComponent } from './admin/shared/components/control-messages.component';
import { Ng2PaginationModule } from 'ng2-pagination';
import { TruncatePipe } from './pipe/exponential-strength.pipe';
import { AgmCoreModule } from 'angular2-google-maps/core';
import { NouisliderModule } from 'ng2-nouislider';
import { MyDatePickerModule } from 'mydatepicker';
//import { BootstrapModalModule } from 'ng2-bootstrap-modal';
import { BsDropdownModule } from 'ngx-bootstrap';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';

//import { PopupLogComponent } from './advertiser/popup/popup-log.component';
import { HeaderMenuComponent } from './common/headermenu.component';
import { HeaderMenuAccountComponent } from './common/headermenuAccount.component';
import { UserHeaderBeforeSignupComponent } from './common/user-header-before-signup.component';
import { AdvHeaderBeforeSignupComponent } from './common/adv-header-before-signup.component';
import { AdvHeaderComponent } from './common/adv-header/adv-header.component';
import { adFooterComponent } from './common/adfooter.component';
import { FooterComponent } from './common/footer.component';
import { UserSideMenuComponent } from './common/usersidemenu.component';
@NgModule({
  declarations: [
    ControlMessagesComponent,
    TruncatePipe,
    HeaderMenuComponent,
    HeaderMenuAccountComponent,
    UserHeaderBeforeSignupComponent,
    AdvHeaderBeforeSignupComponent,
    AdvHeaderComponent,
    adFooterComponent,
    FooterComponent,
    UserSideMenuComponent,
    //PopupLogComponent
  ],
  imports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    Ng2PaginationModule,
    AgmCoreModule.forRoot({
    apiKey: 'AIzaSyCiDwGsfKYQXJmng1YkY6MygWZB6pzYUoA',
    libraries: ['places']
    }),
    NouisliderModule,
    MyDatePickerModule,
    //BootstrapModalModule,
    BsDropdownModule.forRoot(),
    NguiAutoCompleteModule
  ],
  providers: [  
    FormsModule,
    ReactiveFormsModule, 
    CommonModule,
    ControlMessagesComponent,
    Ng2PaginationModule
  ],
  exports: [
        FormsModule,
        ReactiveFormsModule, 
        CommonModule,
        ControlMessagesComponent,
        Ng2PaginationModule,
        TruncatePipe,
        AgmCoreModule,
        NouisliderModule,
        MyDatePickerModule,
        NguiAutoCompleteModule,
        HeaderMenuComponent,
        HeaderMenuAccountComponent,
        UserHeaderBeforeSignupComponent,
        AdvHeaderBeforeSignupComponent,
        AdvHeaderComponent,
        adFooterComponent,
        FooterComponent,
        UserSideMenuComponent
    ],
})
export class SharedAppModule { }



// WEBPACK FOOTER //
// ./src/app/app.shared.module.ts